module.exports = __webpack_public_path__ + "static/img/16.a0ff6616.png";